import { AreaEurekamLiteModel, OrderModel } from './area-eurekam-lite.model';
import { AreaEurekamLiteResource, OrderResource } from './area-eurekam-lite.resource';
import { Serializer } from 'src/app/core/common/http/serializer';

export class AreaEurekamLiteSerializer implements Serializer { 
    fromJson(json: any): AreaEurekamLiteResource { 
    const resource = new AreaEurekamLiteResource();

    resource.id = json.id??null;
    resource.links = json.links??null;
    resource.commesse = json.commesse;
    resource.request_type = json.request_type;
    resource.membership_group = json.membership_group;
    resource.description_group = json.description_group;
    resource.group_name = json.group_name;
    resource.notes = json.notes;
    
    return resource;
  }

  toJson(model: AreaEurekamLiteModel): any  {
    const resource = new AreaEurekamLiteResource();
    
    resource.request_type = model.request_type[0].description;
    console.log('model', model, model.request_type[0].value);
    switch (model.request_type[0].value) {
      case "CREAZIONE_UTENZA":
        console.log('resource', resource);
        if (model.membership_group && model.membership_group.length > 0) {
          resource.membership_group = model.membership_group[0].description;
        }
        break;
      case "CREAZIONE_GRUPPO":
        resource.group_name = model.group_name;
        resource.description_group = model.description_group;
        break;
      case "ABILITAZIONE_COMMESSA":
        resource.commesse = [];
        model.commesse.forEach((order)=>{
          resource.commesse.push(order.project_name)
        });
        break;
    }
    
    resource.notes = model.notes;
   
    return resource;
  }  
}

export class OrderSerializer implements Serializer {
  fromJson(json: any): OrderModel {
    
    const model = new OrderModel();
    model.id = json.segment_code;
    model.project_name = json.project_name;
    model.cdc_type = json.cdc_type;
    model.project_description = json.project_description;

    return model;
  }

  toJson(model: OrderModel): any  {
    const orederResource = new OrderResource();
    orederResource.segment_code = model.id;
    orederResource.active = model.active;
    orederResource.project_name = model.project_name;
    orederResource.project_description = model.project_description;
    
    return orederResource;
  }
}